document.addEventListener('alpine:init', () => {
  Alpine.data('QuantityStepper', () => {
    return {
      quantity: 1,
      step: 1,
      init() {
        if (this.dropdownQuantity) {
          if (this.dropdownQuantity === '10+') {
            this.quantity = 10;
          } else {
            this.quantity = parseInt(this.dropdownQuantity, 10);
          }
        }
        this.quantity = this.$refs.quantityInput.min;
        this.step = this.$refs.quantityInput.step || 1;
      },
      handleQuantityChange() {
        this.removeErrorMessage();
        const maxQuantity = this.$refs.quantityInput.max;
        if (!maxQuantity) return;
        
        if (this.quantity > maxQuantity) {
          this.displayMaxQuantityErrorMessage();
          setTimeout(() => {
            this.quantity = maxQuantity;
            this.dispatchInputChange();
          }, 2000);
        }
      },
      dispatchInputChange() {
        this.$refs.quantityInput.dispatchEvent(
          new Event('change', { bubbles: true })
        );
      },
      decreaseQuantity() {
        this.removeErrorMessage();
        if (this.quantity > this.$refs.quantityInput.min) {
          this.quantity = parseInt(this.quantity, 10) - parseInt(this.step, 10);
        }
        this.dispatchInputChange();
      },
      increaseQuantity() {
        this.removeErrorMessage();
        const maxQuantity = this.$refs.quantityInput.max;
        if (maxQuantity && this.quantity >= maxQuantity) {
          this.displayMaxQuantityErrorMessage();
          return;
        }
        
        this.quantity = parseInt(this.quantity, 10) + parseInt(this.step, 10);
        this.dispatchInputChange();
      },
      removeErrorMessage() { 
        const errorEl = this.$root.querySelector(
          '[data-quantity-input-error]'
        );
        if (errorEl) {
          errorEl.textContent = '';
          errorEl.classList.add('hidden');
        }
      },
      displayMaxQuantityErrorMessage() {
        const errorEl = this.$root.querySelector(
          '[data-quantity-input-error]'
        );
        if (errorEl) {
          errorEl.textContent = "You can't add more than " + this.$refs.quantityInput.max + ' items';
          errorEl.classList.remove('hidden');
        }
      }
    };
  });
});
